// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3ChJd","col":"styles_col__3SZOn","fulfillmentStatus":"styles_fulfillmentStatus__2jWsK","emailCol":"styles_emailCol__3jH2u"};